import { useRole } from '../../hooks/useRole'
import OwnerDashboard from './dashboard/OwnerDashboard.jsx'
import ManagerDashboard from './dashboard/ManagerDashboard.jsx'
import EmployeeDashboard from './dashboard/EmployeeDashboard.jsx'
import { useApp } from '../../store.jsx'
import { Icon } from '../../components/Common.jsx'
import { useNavigate } from 'react-router-dom'

export default function Dashboard() {
  const { goPage } = useApp()
  const navigate = useNavigate()
  const role = useRole()
  if (role === 'employee') return <EmployeeDashboard />
  if (role === 'manager') return <ManagerDashboard />
  if (role === 'admin') {
    return (
      <section>
        <div className="page-head">
          <div>
            <h1 className="page-title">Dashboard</h1>
            <p className="page-sub">Platform admin overview</p>
          </div>
        </div>
        <div className="card" style={{ padding: 32, textAlign: 'center' }}>
          <Icon name="shield" size={32} style={{ opacity: 0.4, marginBottom: 12 }} />
          <h2 style={{ fontSize: 18, marginBottom: 8 }}>Platform Admin</h2>
          <p style={{ color: 'var(--text-muted)', marginBottom: 20, maxWidth: 420, margin: '0 auto 20px' }}>
            You are logged in as a platform administrator. Tenant dashboards are not available
            for your account. Use the Platform section to manage companies, subscriptions, and settings.
          </p>
          <button className="btn btn-primary" onClick={() => goPage('adminOverview')}>
            Go to Platform Overview
          </button>
          <button className="btn btn-ghost" style={{ marginLeft: 8 }} onClick={() => navigate('/app?page=adminOverview')}>
            <Icon name="external-link" size={14} /> Open Platform
          </button>
        </div>
      </section>
    )
  }
  return <OwnerDashboard />
}
